export * from './SwitchDetailsModal.container'
export { default as SwitchDetailsModal } from './SwitchDetailsModal.container'
